import { useAdvancedEasterEggs } from '@/hooks/useAdvancedEasterEggs';

const HiddenCornerTriggers = () => {
  const { handleCornerClick, state } = useAdvancedEasterEggs();

  if (state.cornerSequenceDiscovered) return null;

  return (
    <>
      {/* Invisible corner triggers */}
      <button
        onClick={() => handleCornerClick('top-left')}
        className="fixed top-0 left-0 w-12 h-12 z-[100] opacity-0 cursor-default"
        aria-hidden="true"
        tabIndex={-1}
      />
      <button
        onClick={() => handleCornerClick('top-right')}
        className="fixed top-0 right-0 w-12 h-12 z-[100] opacity-0 cursor-default"
        aria-hidden="true"
        tabIndex={-1}
      />
      <button
        onClick={() => handleCornerClick('bottom-left')}
        className="fixed bottom-0 left-0 w-12 h-12 z-[100] opacity-0 cursor-default"
        aria-hidden="true"
        tabIndex={-1}
      />
      <button
        onClick={() => handleCornerClick('bottom-right')}
        className="fixed bottom-0 right-0 w-12 h-12 z-[100] opacity-0 cursor-default"
        aria-hidden="true"
        tabIndex={-1}
      />
    </>
  );
};

export default HiddenCornerTriggers;
